import { render, staticRenderFns } from "./ProductSalesRankingChart.vue?vue&type=template&id=0cc1e5ba&"
import script from "./ProductSalesRankingChart.vue?vue&type=script&lang=js&"
export * from "./ProductSalesRankingChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports